var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('strong',[_vm._v("Made with "),_c('a',{attrs:{"href":"https://vuejs.org/"}},[_vm._v("Vue")]),_vm._v(" and "),_c('a',{attrs:{"href":"https://vuetifyjs.com/"}},[_vm._v("Vuetify")])])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }